import { useRef } from 'react';
import { ImperativePanelHandle } from 'react-resizable-panels';

export const useResizablePanelRef = () => useRef<ImperativePanelHandle | null>(null);
